import styled from 'styled-components';
import { s } from './NPL.styles';
import { NumberwithComma, ReportFormatNumber } from '../../../../func/Function';
import { NplCalculation } from '../../../../utils/nplAnalysis';

interface IExpectedLoanPrincipalProps {
  expectedLoanPrincipal: ReturnType<NplCalculation['getExpectedLoan']>;
}

const formatDays = (v?: string | number) => {
  if (v == null) return '-';
  const str = String(v).trim();
  return /일$/.test(str) ? str : `${str}일`;
};

const ItemRow = ({
  label,
  content,
}: {
  label: React.ReactNode;
  content: React.ReactNode;
}) => (
  <s.Item>
    <s.ItemLabel>{label}</s.ItemLabel>
    <s.ItemContent>{content}</s.ItemContent>
  </s.Item>
);

const ExpectedLoanPrincipal = (props: IExpectedLoanPrincipalProps) => {
  const { expectedLoanPrincipal } = props;

  const rows = [
    {
      label: '근저당권 설정액',
      content: ReportFormatNumber(expectedLoanPrincipal.row1_1),
    },
    {
      label: '대출원금 (예상)',
      content: ReportFormatNumber(expectedLoanPrincipal.row2_1),
    },
    {
      label: '대출잔액+미수이자 (예상)',
      content: ReportFormatNumber(expectedLoanPrincipal.row3_1),
    },
    {
      label: '연체이자율',
      content: ReportFormatNumber(expectedLoanPrincipal.row1_2, true, true),
    },
    {
      label: '연체 기간 (경매기간)',
      content: formatDays(expectedLoanPrincipal.row2_2),
    },
    {
      label: '연체이자 금액 (경매기간)',
      content: ReportFormatNumber(expectedLoanPrincipal.row3_2),
    },
  ];

  return (
    <s.Div>
      <s.Title>예상 대출원리금</s.Title>
      <div>
        {rows.map((r, i) => (
          <ItemRow key={i} label={r.label} content={r.content} />
        ))}
      </div>
      <div>
        <s.BlueBox>
          <s.LeftCell style={{ color: '#222222' }}>합계금액</s.LeftCell>
          <s.RightCell style={{ color: '#008AFF', fontWeight: '700' }}>
            {ReportFormatNumber(expectedLoanPrincipal.row4)}
          </s.RightCell>
        </s.BlueBox>

        <s.Description style={{ marginTop: '8px' }}>
          <img
            src="/assets/images/icon/info_16.svg"
            alt=""
            style={{ width: 16 }}
          />
          <span>
            예상 대출원리금은 대출 금융기관의 확인이 반드시 필요합니다.
          </span>
        </s.Description>
      </div>
    </s.Div>
  );
};

export default ExpectedLoanPrincipal;

const Table = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  border: 1px solid #e5e8ea;
`;
